<script>
import Layout from "@layouts/form";
import TarefaPrioridade from "@forms/TarefaPrioridade";

export default {
  page: {
    title: "Detalhes | Prioridade da tarefa"
  },
  components: { Layout, TarefaPrioridade },
  props: {
    editable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      title: "Prioridade da Tarefa",
      items: [
        {
          text: "Cadastros",
          href: "/Cadastros"
        },
        {
          text: "Prioridade da Tarefa",
          href: "/TarefaPrioridade"
        },
        {
          text: "Edição",
          active: true
        }
      ]
    };
  }
};
</script>

<template>
  <Layout :title="title" :items="items">
    <div class="page-content">
      <TarefaPrioridade :editable="editable"></TarefaPrioridade>
    </div>
  </Layout>
</template>
